/** Brand shown to brokers and clients. Set with PUBLIC_NAME at build time. */
export const PUBLIC_NAME: string = __PUBLIC_NAME__;

/** The company behind the product, named in legal footers. Set with COMPANY_NAME at build time. */
export const COMPANY_NAME: string = __COMPANY_NAME__;

/** The app version the guide describes. Set from RELEASE, or the web package version, at build time. */
export const APP_VERSION: string = __APP_VERSION__;

/** The day this build was made (ISO), shown in words on the guide. */
export const BUILD_DATE: string = __BUILD_DATE__;
